document.addEventListener("DOMContentLoaded", function () {
  // ===== 既存：メインスライダー =====
  document.querySelectorAll('.main-slider').forEach(function (element) {
    $(element).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3500,
    });
  });

  // ===== 既存：.cmmpulse-list は480px以下でだけslick化 =====
  let slickInitializedCmmpulse = false;

  function toggleCmmpulseSlick() {
    if (window.innerWidth <= 480) {
      if (!slickInitializedCmmpulse) {
        document.querySelectorAll('.cmmpulse-list').forEach(function (element) {
          $(element).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            infinite: false,
          });
        });
        slickInitializedCmmpulse = true;
      }
    } else {
      if (slickInitializedCmmpulse) {
        document.querySelectorAll('.cmmpulse-list').forEach(function (element) {
          $(element).slick('unslick');
        });
        slickInitializedCmmpulse = false;
      }
    }
  }

  toggleCmmpulseSlick();
  window.addEventListener("resize", toggleCmmpulseSlick);

  // ===== 既存：.more-btn アコーディオン & スクロール =====
  document.querySelectorAll('.more-btn').forEach(function (button) {
    button.addEventListener('click', function () {
      document.querySelectorAll('.acc').forEach(function (accElement) {
        accElement.classList.toggle('show');
      });
      button.classList.toggle('open');

      // ページ内スクロールを追加
      if (!document.querySelector('.acc').classList.contains('show')) {
        const target = document.querySelector('#table-function');
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      }
    });
  });

  // ===== 既存：.item-img → 次の.item-box の開閉 =====
  document.querySelectorAll('.item-img').forEach(function (imgElement) {
    imgElement.addEventListener('click', function () {
      const nextItemBox = imgElement.nextElementSibling;
      if (nextItemBox && nextItemBox.classList.contains('item-box')) {
        nextItemBox.classList.toggle('show');
        imgElement.classList.toggle('open');
      }
    });
  });

  // ===== 追加：howto-image の横スクロール進捗バー（複数対応） =====
  const INITIAL_PROGRESS_PERCENT_MOBILE = 30; // 初期バー表示率（％）

  function getMinProgressRatio() {
    return window.matchMedia('(max-width: 480px)').matches
      ? INITIAL_PROGRESS_PERCENT_MOBILE / 100
      : 0;
  }

  function attachHowtoProgress(howtoArea, howtoBar) {
    function update() {
      if (!howtoArea || !howtoBar) return;

      const max = Math.max(0, howtoArea.scrollWidth - howtoArea.clientWidth);
      if (max <= 0) {
        howtoBar.style.width = '0%';
        return;
      }

      const minPx = Math.min(max * getMinProgressRatio(), max);
      const effectiveScroll = Math.max(howtoArea.scrollLeft, minPx);
      const rate = effectiveScroll / max;

      howtoBar.style.width = (rate * 100) + '%';
    }

    // 初期反映
    update();

    // スクロール・リサイズで更新
    howtoArea.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    // 画像ロード後にも再計算
    const img = howtoArea.querySelector('img');
    if (img) {
      if (!img.complete) {
        img.addEventListener('load', update, { once: true });
      } else {
        update();
      }
    }
  }

  // ページ内の全ての .howto-image と直後の .howto-progress を紐付け
  document.querySelectorAll('.howto-image').forEach(function (area) {
    const bar = area.nextElementSibling?.querySelector('.bar');
    if (bar) {
      attachHowtoProgress(area, bar);
    }
  });

  // ===== 追加：スクロールロック ユーティリティ =====
  let __scrollY = 0;
  function lockScroll() {
    if (document.body.dataset.scrollLocked === '1') return;
    __scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.dataset.scrollLocked = '1';
    document.body.style.position = 'fixed';
    document.body.style.top = (-__scrollY) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }
  function unlockScroll() {
    if (document.body.dataset.scrollLocked !== '1') return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    document.body.dataset.scrollLocked = '';
    window.scrollTo(0, __scrollY);
  }
  function unlockIfNoModalShown() {
    const anyOpen = document.querySelector('.medical-feature__modal.show');
    if (!anyOpen) unlockScroll();
  }
  function isModalOpen() {
    return !!document.querySelector('.medical-feature__modal.show');
  }

  // ===== 追加：medical-feature モーダル（iPhone対策入り） =====

  // 0) .modal-close の操作性を上げる（念のため）
  document.querySelectorAll('.modal-close').forEach(function (el) {
    el.style.touchAction = 'manipulation'; // iOSの300ms遅延等の回避ヒント
    el.setAttribute('role', el.getAttribute('role') || 'button');
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
  });

  // 1) modal-close 最優先ハンドラ（capture段階）
  function closeNearestModal(el) {
    const modal = el.closest('.medical-feature__modal') || document.querySelector('.medical-feature__modal.show');
    if (modal) {
      modal.classList.remove('show');
      unlockIfNoModalShown();
    }
  }
  function onCloseTapCapture(e) {
    const btn = e.target.closest('.modal-close');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    closeNearestModal(btn);
  }
  // iPhoneでの取りこぼし防止：pointerup + touchstart(passive:false) + click
  document.addEventListener('pointerup', onCloseTapCapture, true);
  document.addEventListener('touchstart', onCloseTapCapture, { capture: true, passive: false });
  document.addEventListener('click', onCloseTapCapture, true);

  // 2) 開く & 背景クリックで閉じる（バブリングでOK）
  document.addEventListener('click', function (e) {
    // 開く
    const btn = e.target.closest('.medical-feature__btn');
    if (btn) {
      e.preventDefault();
      const root = btn.closest('.medical-feature') || document;
      const modal = root.querySelector('.medical-feature__modal') || document.querySelector('.medical-feature__modal');
      if (modal) {
        modal.classList.add('show');
        lockScroll();
      }
      return;
    }

    // 背景クリックで閉じる（.modal-image 以外をクリック）
    const modal = e.target.closest('.medical-feature__modal');
    if (modal) {
      if (!e.target.closest('.modal-image')) {
        modal.classList.remove('show');
        unlockIfNoModalShown();
      }
    }
  });

  // 3) アンカーリンクのスムーズスクロール（ロック考慮）
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href || href === '#' || href === '#0') return;

    const target = document.querySelector(href);
    if (!target) return;

    e.preventDefault();

    const doScroll = () => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    if (isModalOpen()) {
      document.querySelectorAll('.medical-feature__modal.show').forEach(function (m) {
        m.classList.remove('show');
      });
      unlockIfNoModalShown();
      requestAnimationFrame(doScroll);
    } else {
      doScroll();
    }
  });
});
